import { render } from "./textarea.vue?vue&type=template&id=224b9715"
import script from "./textarea.vue?vue&type=script&lang=ts"
export * from "./textarea.vue?vue&type=script&lang=ts"
script.render = render

export default script